import {
  RecommendSizeChartErrorResponse,
  RecommendSizeChartGender,
  RecommendSizeChartResponse,
  RecommendSizeCharFootSize,
} from "~/types/server/api/recommend/size_chart"
import { useLocalUser } from "~/composables/useLocalUser"

export const useSizeCheck = () => {
  const { getLocalUserId } = useLocalUser()

  const fetchRecommendSizeChart = async (
    product_id: string,
    gender: RecommendSizeChartGender,
    isFootCategory: boolean,
    height?: number,
    weight?: number,
    foot_size?: RecommendSizeCharFootSize,
  ): Promise<{
    results: RecommendSizeChartResponse
    errorMessage: string
  }> => {
    const errorMessage = ref<string>("")
    const results = ref<RecommendSizeChartResponse>({
      heights: [],
      weights: [],
      apparelRecommendSizes: [],
      footRecommendSizes: [],
      footSizes: [],
    })

    try {
      const res = await $fetch<RecommendSizeChartResponse | RecommendSizeChartErrorResponse>(
        "/api/recommend/size_chart",
        {
          method: "POST",
          body: {
            local_user_id: getLocalUserId(),
            product_id,
            height,
            weight,
            gender,
            foot_size,
            is_foot_category: isFootCategory,
          },
        },
      )
      if ("error" in res) {
        if (res.error === "out_of_range") {
          isFootCategory
            ? (errorMessage.value = "入力された足のサイズは推奨範囲外です")
            : (errorMessage.value = "入力された身長・体重は推奨範囲外です")
        } else if (res.error === "input_form_not_filled_in") {
          errorMessage.value = "必要な項目を入力してください"
        } else {
          throw new Error(res.error)
        }
      } else {
        results.value = res
      }
    } catch (error) {
      errorMessage.value = "サーバーエラーが発生しました"
    }
    return { results: results.value, errorMessage: errorMessage.value }
  }

  return { fetchRecommendSizeChart }
}
